import { useMemo } from 'react';
import { useTypedQuery } from 'apiTyped/helpers/useTypedQuery';
import type { MarketRow } from 'v2/pages/ListMarkets.types';

export interface MarketsFilters {
  channel?: string | null;
  brand?: string | null;
  productType?: string | null;
}

export const useMarkets = (filters: MarketsFilters = {}) => {
  const { isLoading, data, refetch } = useTypedQuery('get', '/v2/markets/', {
    params: {
      query: {
        channel: filters.channel ?? undefined,
        brand: filters.brand ?? undefined,
        product_type: filters.productType ?? undefined
      }
    }
  });

  const markets: MarketRow[] = useMemo(() => {
    if (!data?.markets) return [];
    return data.markets.map((m) => ({
      id: m.id,
      name: m.name,
      flag: m.flag,
      tier: m.tier,
      cities: m.cities,
      accountsSurveyed: m.accounts_surveyed,
      dnLastYear: m.dn_last_year,
      gained: m.gained,
      lost: m.lost,
      notSurveyed: m.not_surveyed,
      newlySurveyed: m.newly_surveyed,
      net: m.net
    }));
  }, [data]);

  return {
    isLoading,
    markets,
    refetch
  };
};
